module.exports = __webpack_public_path__ + "static/media/credit.8b319bee.scss";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/credit/credit.scss
// module id = 222
// module chunks = 0